import { render, staticRenderFns } from "./KeywordMenu.vue?vue&type=template&id=023f3da1&scoped=true&"
import script from "./KeywordMenu.vue?vue&type=script&lang=js&"
export * from "./KeywordMenu.vue?vue&type=script&lang=js&"
import style0 from "./KeywordMenu.vue?vue&type=style&index=0&id=023f3da1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023f3da1",
  null
  
)

export default component.exports